import { render, staticRenderFns } from "./SyariahIndex.vue?vue&type=template&id=6b952814&"
import script from "./SyariahIndex.vue?vue&type=script&lang=js&"
export * from "./SyariahIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports